<div class="mb-3">
  <label *ngIf="hasLabel" [attr.for]="resolvedInputId">{{ label | translate }}</label>
  <div class="input-group mb-3">
    <input
      [attr.id]="resolvedInputId"
      type="text"
      class="form-control"
      [value]="displayValue"
      (input)="onInput($event)"
      (paste)="onPaste($event)"
      [placeholder]="placeholder | translate"
      [required]="required"
      [disabled]="disabled"
      [attr.autocomplete]="autocomplete"
      [attr.spellcheck]="false"
    >
    <span
      class="input-group-text cursor-pointer"
      [attr.id]="resolvedInputId ? resolvedInputId + '-visibility' : null"
      (click)="toggleVisibility()"
    >
      <i class="bi bi-eye-fill" *ngIf="!showPassword"></i>
      <i class="bi bi-eye-slash-fill" *ngIf="showPassword"></i>
    </span>
  </div>

  <div *ngIf="hasHint" class="form-text">{{ hint | translate }}</div>
  <div *ngIf="showError" class="form-text text-danger">{{ error | translate }}</div>
</div>
